export const AgentDesktopPermissions = () => {
    return <div>Agent Desktop Permissions Page</div>;
};
